import $ from 'jquery';

const appraisalSelector = $('.js-appraisal-request-select');
const appraisalButton = $('.js-appraisal-request-button');

appraisalSelector.on('change', () => {

    window.setTimeout(() => {
        const appraisalSelected = $('.appraisal-request__select .select2-selection__rendered').text();

        if (appraisalSelected === 'Sales appraisal') {
            appraisalButton.attr('href', `${window.location.origin}/sale-apprisal`);
        } else {
            appraisalButton.attr('href', `${window.location.origin}/rental-appraisal`);
        }
    }, 100);
});
